import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = [ 'parent', 'frame' ]

  connect() {
    if(this.element.complete && !this.element.busy) {
      setTimeout(()=> this.element.src = this.element.src + '&random=' + Math.random())
    }
  }
}

